import { Injectable } from '@angular/core';
import { NgbActiveModal, NgbModal, NgbModalRef, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { DialogConfirmComponent } from './dialog-confirm/dialog-confirm.component'
import *  as t from './dialog-index';
import { ButtonProperty } from './dialog-button';
import { DialogOption } from './dialog-option';


@Injectable({
  providedIn: 'root'
})
export class DialogService {
  Option: DialogOption;
  modalRef: NgbModalRef;
  modalOption: NgbModalOptions = {};

  constructor(private _modalService: NgbModal) {
  }

  Show() {
    this.modalOption.backdrop = 'static';
    this.modalOption.keyboard = false;
    this.modalRef = this._modalService.open(DialogConfirmComponent, this.modalOption);
    this.modalRef.componentInstance.dlgOption = this.Option;

    return this.modalRef.result;
  }

  /**
   * @param customHeader string optional : default header - Submit Successfully!!
   * @param customMessage string optional : default message - Back to edit another or keep on this page
   * @param btnTexts string[] optional : default btnTexts - Back , Keep
   * @returns NgbModalRef.result : choiced button text , default return Back or Keep
   */
  private Dialog(customHeader: string = 'Submit Successfully!!',
    customMessage: string = 'Back to edit another or keep on this page',
    btnTexts: string[] = ['Back', 'Keep'],
    customMessageClass: string = 'Success') {

    let btnProperties: ButtonProperty[];
    btnProperties = btnTexts.map((val) => {
      return { text: val, btnFunction() { return true; } };
    })

    let MessageClass = '';
    if (customMessageClass == "Success") {
      MessageClass = t.MessageType.Success;
    } else if (customMessageClass == "Warning") {
      MessageClass = t.MessageType.Warning;
    } else if (customMessageClass == "Error") {
      MessageClass = t.MessageType.Error;
    } else {
      MessageClass = t.MessageType.Info;
    }

    let dlgOption: DialogOption = {
      header: customHeader,
      message: customMessage,
      messageClass: MessageClass,
      buttons: btnProperties
    };


    this.modalOption.backdrop = 'static';
    this.modalOption.keyboard = false;
    this.modalRef = this._modalService.open(DialogConfirmComponent, this.modalOption);
    this.modalRef.componentInstance.dlgOption = dlgOption;

    return this.modalRef.result;
  }

  CreateSubmit() {
    return this.Dialog('Success', 'Back to search page or create another', ['Back', 'Create Another']);
  }

  EditSubmit() {
    return this.Dialog('Success', 'Back to search page or keep on this page', ['Back', 'Keep']);
  }

  DeleteQuestion() {
    return this.Dialog('Warning', 'Are you sure you want to delete this record?', ['Yes', 'No'], "Warning");
  }

  ErrorInformation(message: any) {
    let content = '';
    if (message == null || message.length == 0) {
      content = 'When call API,it throws error'
    } else {
      if(typeof (message) == 'string')
      {
        content = message
      }
      else
      {
      message.forEach(element => {
        content += (element + '<br\>')
      });;   
    } 
      content = content.substring(0, 200);
    }
    return this.Dialog('Error', content, ['Ok'], "Error");
  }

  Warning(message: any, msgOnly: boolean = false)
  {
    let content = '';
    if (message == null || message.length == 0) {
      content = 'When call API,it throws warning'
    } else {
      if(typeof (message) == 'string')
      {
        content = message
      }
      else
      {
        message.forEach(element => {
          content += (element + '<br\>')
      });;   
    } 
      content = content.substring(0, 200) + 'Do you wish to continue?';
    }
    return this.Dialog('Warning', content, msgOnly ? ['Ok'] : ['Yes', 'Cancel'], "Warning");
  }

  UploadSucess(fileName: string) {
    return this.Dialog('Success', 'Upload successfully', ['Ok']);
  }

  SingleButtonSubmit() {
    return this.Dialog('Success', 'Keep on this page', ['Ok']);
  }

  ShowSucess(msg: string) {
    return this.Dialog('Success', msg, ['Ok']);
  }

  BackButtonSubmit(){
    return this.Dialog('Success', 'Update successfully! Back to search page.', ['Back']);   
  }

}
